import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import type { RouteProps } from 'react-router-dom';

import GlobalLoading from 'v2/components/Shared/GlobalLoading';
import PermissionHide from 'v2/components/Shared/PermissionHide';

interface IProps extends RouteProps {
  action?: string | string[];
}

const PermissionRoute: React.FC<IProps> = ({ action, ...routeProps }) => {
  return (
    <Suspense fallback={<GlobalLoading />}>
      <PermissionHide action={action} fallback={<Redirect to='/' />}>
        <Route {...routeProps} />
      </PermissionHide>
    </Suspense>
  );
};

export default PermissionRoute;
